export { useGraphCanvasPermissions } from './api/use-graph-canvas-permissions';
export { canAddAnything } from './model/canvas-panels';
export { isCanvasReleased } from './model/canvas-release';
export { graphCanvasRoute } from './route';

export const loadGraphCanvasPage = async () => {
    const { GraphCanvasPage } = await import('./GraphCanvasPage');

    return { Component: GraphCanvasPage };
};
